<template>
  <div>
    <common-dialog ref="dialog" width="300px" center title="导入 人员信息" @closed="onClosed">
      <template slot="form">
        <div style="text-align: center;margin-bottom: 30px;">
          <div style="margin-top: 15px;">
            <import-file :upload-url="api.import" text="导入 人员信息" @on-uploaded="uploaded" />
          </div>
          <div style="margin-top: 15px;">
            <el-button style="width: 150px;" plain @click="download">下载信息模板</el-button>
          </div>
          <div style="margin-top: 15px;" v-if="detailUrl">
            <el-button style="width: 150px;" type="danger" plain @click="detail">下载错误明细</el-button>
          </div>
        </div>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import importFile from "@/components/common/files/importFile";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    importFile,
  },
  data() {
    return {
      api: require("@/api/sy/role").default,
      attach: require("@/api/common/attach").default,
      detailUrl: "",
    };
  },
  computed: {},
  methods: {
    download() {
      var name = "部门导入模板.xlsx";
      this.attach.downloadByUrl("/Template/" + name, name);
    },
    detail() {
      this.attach.downloadByUrl(this.detailUrl, "错误明细.xlsx");
    },
    uploaded(res) {
      console.log("uploaded", res);
      this.$refs.dialog.isChange = false;
      if (res.Code != 0) {
        if (res.Code == 2) {
          this.detailUrl = res.Data;
        } else {
          this.$message.error(res.Msg);
        }
      } else {
        this.$emit("upload-success");
        this.detailUrl = "";
        this.close(true);
      }
    },
    onClosed() {
      this.detailUrl = "";
    },
  },
};
</script>